import { usePartner } from "../../context/PartnerContext";

const BackHeader = ({ onBack }) => {
  const { config } = usePartner() || {};
  const partnerName = config?.name || "Physica Physiotherapy";

  return (
    <div className="relative flex items-center justify-center px-4 py-3 min-h-[64px]">
      {/* Back Button */}
      <button
        onClick={onBack}
        className="absolute left-4 flex items-center justify-center w-10 h-10"
        aria-label="Back"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.10841 0.228163C7.39181 0.531457 7.39082 1.02214 7.10619 1.32413L2.48697 6.22512H15.2727L15.3714 6.2322C15.7264 6.28351 16 6.60775 16 7.00009C16 7.42809 15.6744 7.77505 15.2727 7.77505H2.48848L7.10624 12.6759L7.17682 12.7627C7.38866 13.0656 7.36602 13.4962 7.10837 13.7719C6.82494 14.0752 6.36446 14.0762 6.07986 13.7742L0.213264 7.5486L0.210346 7.54501C0.187782 7.5207 0.166718 7.49481 0.147311 7.4675L0.142491 7.46157C-0.0698261 7.15771 -0.046217 6.72568 0.213306 6.45032L6.0799 0.225803L6.16162 0.150955C6.44679 -0.0734968 6.85077 -0.0475585 7.10841 0.228163Z"
            fill="#000000"
          />
        </svg>
      </button>

      {/* Centered Title — wraps gracefully */}
      <h1
        style={{ color: "var(--partner-secondary)" }}
        className="text-base sm:text-lg font-bold text-center px-4 leading-tight break-words max-w-[80%]"
      >
        {partnerName} Session Booking
      </h1>
    </div>
  );
};

export default BackHeader;
